import React, { useState, useEffect } from "react";
import { API, Auth } from "aws-amplify";
import {
  AmplifyProvider,
  View,
  Button,
  Flex,
  TextField,
  Text,
  Heading,
  Divider,
  Card,
} from "@aws-amplify/ui-react";
import { Link } from "react-router-dom";
import Tables from "./table/table";
import { useSelector } from "react-redux";

export const AppleSearch = () => {
  const [name, setName] = useState("");
  const [albums, setAlbums] = useState([]);
  const buttonControl = name.length > 0;
  const [itemLength, setItemLength] = useState(1);
  const [loading, setLoading] = useState(false)
  const selector = useSelector((state) => state);
  console.log(selector);

  const changeName = (e) => setName(e.currentTarget.value);
  const fetchAppleAlbumData = async () => {
    setLoading(true)
    const user = await Auth.currentAuthenticatedUser();
    const token = user.signInUserSession.idToken.jwtToken;

    const requestInfo = {
      headers: {
        Authorization: token,
      },
      queryStringParameters: {
        // OPTIONAL
        appleAlbumName: name,
      },
    };

    const items = [];
    await API.get("appleSearch", "/prd", requestInfo)
      .then((response) => {
        console.log("recode=======-")
        console.log(itemLength)
        if (Object.keys(response["results"]).length === 0) {
          setItemLength(0)
        } else {
          setItemLength(1)
          const recode = response["results"]["albums"]["data"];
          recode.forEach((element) => {
            const item = {
              albumId: element.id,
              albumName: element.attributes.name,
              artistName: element.attributes.artistName,
            };
            items.push(item);
          });
        }
        setLoading(false)
        setAlbums(items);
      })
      .catch((error) => {
        console.log(error.response);
      });
  };


  const handleKeyDown = async (e) => {
    if (e.key === 'Enter') {
      fetchAppleAlbumData()
      e.preventDefault();
    }
  };

  // close the browser tab  
  const handleBeforeUnloadEvent = (event: BeforeUnloadEvent): void => {
    event.returnValue = "";
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnloadEvent);
    return () => window.removeEventListener("beforeunload", handleBeforeUnloadEvent);
  }, []);

  console.log(itemLength)
  useEffect(() => {
    setAlbums(albums);
  }, [albums]);

  return (
    <AmplifyProvider >
      <Card>

        {/* ヘッダー下:begin ---- */}
        <View as="div" paddingBottom="1rem">
          <Flex direction="column" gap="1rem">
            <Heading level={5}>{"[Apple MusicアルバムID検索]"}</Heading>
            <Text fontSize="13px">
              {'Pre-Save/Pre-Add登録システムの「AppleMusicアルバムID検索ページ」です。アルバム名・アーティスト名等のキーワードでAppleMusicに登録されたアルバムIDを検索します。'}
              <br />
              {'前の画面に戻る場合には『戻る』ボタンを押してください。'}
            </Text>
          </Flex>
        </View>
        {/* ヘッダー下:end ---- */}

        {/* 検索フォーム:begin ---- */}
        <View as="div" paddingBottom="1rem">
          <View as="div" backgroundColor='#ccc' padding="0.3rem">
            <Heading level={6}>{'■Apple MusicアルバムID検索'}</Heading>
          </View>

          <View as="div" padding="0.75rem">
            <Flex direction="column" gap="1rem">
              {/* 説明文 */}
              <Flex direction="column" gap="0rem" fontSize="13px">
                <Text>{'アルバム名・アーティスト名等のキーワードを入力して『検索』ボタンを押してください。'}</Text>
              </Flex>

              {/* 区切り線 */}
              <Divider orientation="horizontal" />

              {/* インプット */}
              <Flex as="form" direction="row" >
                <Text width="8rem" padding="0.5rem">{'キーワード'}</Text>
                <TextField
                  as="input"
                  label=""
                  onKeyDown={handleKeyDown}
                  labelHidden={true}
                  isRequired={true}
                  onChange={changeName}
                  size="small"
                  style={{ width: "25rem", height: "2.5rem" }}
                />
                <Button
                  width="10rem"
                  height="2.5rem"
                  disabled={!buttonControl}
                  onClick={fetchAppleAlbumData}>
                  {'検索'}
                </Button>
              </Flex>
            </Flex>
          </View>
        </View>
        {/* 検索フォーム:end ---- */}

        {/* 検索結果:begin ---- */}
        <View as="div" paddingBottom="1rem">

          <View as="div" backgroundColor='#ccc' padding="0.3rem">
            <Heading level={6}>{'■Apple MusicアルバムID一覧'}</Heading>
          </View>

          <View as="div" padding="0.75rem">
            <Flex direction="column" gap="1rem">

              {/* 説明文 */}
              <Flex direction="column" gap="0rem" fontSize="13px">
                <Text>
                  {'表示された一覧からお探しのアルバムの左にある『決定』ボタンを押してください。'}
                  <br />{'登録画面にアルバムIDが自動的に入力されます。'}
                </Text>
              </Flex>

              <Divider orientation="horizontal" />
              <React.Fragment>
                <Tables items={albums} loading={loading} />
              </React.Fragment>

            </Flex>
          </View>

        </View>
        {/* 検索結果:end   ---- */}

        {/* 戻るボタン */}
        <Divider orientation="horizontal" />
        <Flex direction="row" justifyContent="left" padding="1rem">
          <Button>
            <Link to="/edit" style={{ textDecoration: 'none', color: 'black' }} >{'戻る'}</Link>
          </Button>
        </Flex>

      </Card>
    </AmplifyProvider>
  );
};
